import Vue from 'vue'
import Router from 'vue-router'
import Play from './play'
import Site from './site'
import Rules from './rules'

Vue.use(Router)
const router = new Router({
    mode: 'history',
    routes: [
        Play,
        Site,
        Rules,
        {
            path: '*',
            redirect: ({ path, query }) => {
                let to = path.substr(path.lastIndexOf('/') + 1, path.length)
                if(!["rules","support","legal","home"].includes(to)){
                    to = "home"
                }
                console.log(to)
                return { path: `site/${to}`, query }
            },
        },
        
        // {
        //     path: '*',
        //     redirect: ({ path, query }) => {
        //         let to = path.substr(path.lastIndexOf('/') + 1, path.length)
        //         //let paths = ["play"]
        //         console.log("to", to)
        //         if("play" != to || !path){
        //             to = "play"
        //         }                
        //         return { path: `/${to}`, query }
        //     }
        // }
    ]
})
export default router